import { useState } from "react";
import { motion, AnimatePresence, useMotionValueEvent, useScroll } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { TEL_LINK, WHATSAPP_URL } from "../lib/site";
import { useLang } from "../lib/i18n";

export const MobileStickyBar = () => {
  const [visible, setVisible] = useState(false);
  const { scrollY } = useScroll();
  const { t } = useLang();
  useMotionValueEvent(scrollY, "change", (v) => setVisible(v > 320));

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-50 border-t border-edge/50 bg-white/90 backdrop-blur-md md:hidden"
          data-testid="mobile-sticky-bottom-bar"
        >
          <div className="grid grid-cols-2 gap-3 px-4 py-3">
            <a href={TEL_LINK} className="flex items-center justify-center gap-2 rounded-[10px] bg-amber py-3.5 font-archivo text-sm font-bold text-[#181510] active:bg-amberdeep" data-testid="mobile-sticky-call-button">
              <Phone size={16} strokeWidth={2.5} />
              {t.callNow}
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 rounded-[10px] bg-wa py-3.5 font-archivo text-sm font-bold text-white active:bg-wadeep"
              data-testid="mobile-sticky-whatsapp-button"
            >
              <MessageCircle size={16} strokeWidth={2.5} />
              {t.whatsappUs}
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
